<div class="component-viewer">

    <!-- Scheduler container -->
    <div class="simulator-calendars">
        <!-- Toolbar skeleton -->
        <div class="scheduler-toolbar">
            <div class="toolbar-left">
                <!-- Navigation buttons and date picker -->
                <div class="date-navigation">
                    <ngx-skeleton-loader count="1" [theme]="{
                        height: '40px',
                        width: '40px',
                        borderRadius: '50%'
                    }" />
                    
                    <ngx-skeleton-loader count="1" [theme]="{
                        height: '40px',
                        width: '120px',
                        borderRadius: '4px'
                    }" />
                    
                    <ngx-skeleton-loader count="1" [theme]="{
                        height: '40px',
                        width: '40px',
                        borderRadius: '50%'
                    }" />
                </div>
            </div>
            
            <div class="toolbar-right">
                <!-- Today button and view selector -->
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '32px',
                    width: '60px',
                    borderRadius: '4px'
                }" />
                
                <ngx-skeleton-loader count="1" [theme]="{
                    height: '32px',
                    width: '80px',
                    borderRadius: '4px'
                }" />
            </div>
        </div>
        
        <!-- Schedule grid skeleton -->
        <div class="schedule-grid">
            <!-- Resource headers -->
            <div class="resource-headers">
                <div class="resource-header" *ngFor="let simulator of [1,2,3,4]">
                    <ngx-skeleton-loader count="1" [theme]="{
                        height: '20px',
                        width: '80%',
                        borderRadius: '4px'
                    }" />
                </div>
            </div>
            
            <!-- Time slots and cells -->
            <div class="schedule-content">
                <div class="time-column">
                    <div class="time-slot" *ngFor="let hour of timeSlots">
                        <ngx-skeleton-loader count="1" [theme]="{
                            height: '16px',
                            width: '40px',
                            borderRadius: '2px'
                        }" />
                    </div>
                </div>
                
                <div class="simulator-columns">
                    <div class="simulator-column" *ngFor="let simulator of [1,2,3,4]">
                        <div class="time-cell" *ngFor="let hour of timeSlots">
                            <ngx-skeleton-loader count="1" [theme]="{
                                height: '60px',
                                width: '100%',
                                borderRadius: '2px'
                            }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
